import { render } from "./privacy-accessibility.vue?vue&type=template&id=5ebd3aaa&scoped=true"
import script from "./privacy-accessibility.vue?vue&type=script&lang=js"
export * from "./privacy-accessibility.vue?vue&type=script&lang=js"

import "./privacy-accessibility.vue?vue&type=style&index=0&id=5ebd3aaa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ebd3aaa"]])

export default __exports__